const FUNCTIONS = {
  contract: "Contrato",
  admin: "Administração",
  dashboard: "Painel",
  "my-publications": "Minhas Publicações",
  "my-orders": "Meus Pedidos",
  tables: "Calculadora",
  billing: "Publique Aqui",
};
const ADMIN_TOOLS = {
  files: "Arquivos de impressão",
  publications: "Publicações",
  categories: "Categorias",
  production: "Produção e entrega",
  tray: "Conexão Tray",
  contract: "Contrato e PDF",
  coverage: "Cobertura do miolo",
  users: "Usuários e permissões",
};
const DEFAULT_FUNCTIONS = Object.keys(FUNCTIONS).filter((key) => key !== "admin");
function hasFunction(access, key) {
  return Boolean(access?.active && access.functions?.includes(key));
}
function hasTool(access, key) {
  return hasFunction(access, "admin") && access.adminTools?.includes(key);
}
function routeFunction(path) {
  if (path === "/contrato") return "contract";
  if (path === "/admin") return "admin";
  if (path === "/dashboard") return "dashboard";
  if (path.startsWith("/my-publications")) return "my-publications";
  if (path === "/my-orders") return "my-orders";
  if (path === "/calculator") return "tables";
  if (path === "/publish-here") return "billing";
  return null;
}
module.exports = { FUNCTIONS, ADMIN_TOOLS, DEFAULT_FUNCTIONS, hasFunction, hasTool, routeFunction };
